import { Evento } from '@/types';
import { LABELS } from '@/lib/labels';
import { formatMeseAnno } from '@/lib/dateUtils';
import CalendarioItem from './CalendarioItem';

interface Props {
  eventi: Evento[];
  vista?: 'futuri' | 'archivio';
}

function groupByMonth(eventi: Evento[]): Record<string, Evento[]> {
  return eventi.reduce<Record<string, Evento[]>>((acc, evento) => {
    const key = formatMeseAnno(evento.data);
    if (!acc[key]) acc[key] = [];
    acc[key].push(evento);
    return acc;
  }, {});
}

export default function CalendarioList({ eventi, vista = 'futuri' }: Props) {
  if (eventi.length === 0) {
    return (
      <div className="text-center py-20">
        <p className="font-chalk text-3xl text-chalk-dim">
          {vista === 'archivio' ? LABELS.calendario.vuotoArchivio : LABELS.calendario.vuotoFuturi}
        </p>
        {vista === 'futuri' && (
          <p className="text-chalk-muted mt-2 text-sm">{LABELS.calendario.vuotoFuturiSub}</p>
        )}
      </div>
    );
  }

  const grouped = groupByMonth(eventi);

  return (
    <div className="space-y-12">
      {Object.entries(grouped).map(([mese, eventiMese]) => (
        <section key={mese}>
          <div className="flex items-center gap-4 mb-6">
            <h2 className="font-chalk text-2xl md:text-3xl text-accent-orange uppercase tracking-wider capitalize">{mese}</h2>
            <div className="flex-1 border-t border-dashed border-chalk/20" aria-hidden="true" />
          </div>
          <div className="space-y-4">
            {eventiMese.map((evento) => (
              <CalendarioItem key={evento.slug} evento={evento} />
            ))}
          </div>
        </section>
      ))}
    </div>
  );
}